import moment from 'moment'

export const adultValidator = function (travellers) {
  let adults = 0
  let childrens = 0
  if (this.outwardDate) { // OutwardDate is a variable you find in the context of the component who import this validator
    for (const traveller of travellers) {
      const departureDate = moment(this.outwardDate)
      const birthday = moment(traveller.birthday)
      const ageAtDeparture = departureDate.diff(birthday, 'years')
      if (ageAtDeparture >= 18) {
        adults += 1
      } else {
        childrens += 1
      }
    }
    return !(adults === 0 && childrens > 0)
  } else {
    return true
  }
}
